import { CartAddEvent } from '@theme/events';

(()=>{
  document.addEventListener(CartAddEvent.eventName, renderRecs);
  setTimeout(renderRecs, 3500);

  async function renderRecs() {
    try {
      const cart = await getCart();
      if (cart.items.length === 0) return;

      const productId = cart.items[0].product_id;
      const products = await getRecommendations(productId);

      if (products.length > 0) {
        renderProductCards(products);
      }
    } catch (err) {
      console.error('renderRecs failed:', err);
    }
  }

  async function getRecommendations(productId) {
    const complementary = await fetchRecommendations(productId, 'complementary');
    if (complementary.length > 0) return complementary;
    if (document.getElementsByClassName('cart-drawer-recommendations-wrapper')[0].dataset.relatedFallback == "true"){
      return fetchRecommendations(productId, 'related');
    } else {
      return [];
    }
  }

  async function fetchRecommendations(productId, intent) {
    const url = `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=3&intent=${intent}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch ${intent} recommendations`);
    const { products } = await res.json();
    return products;
  }

  function renderProductCards(products) {
    const container = document.querySelector('.cart-drawer-recommendations');

    products.forEach(({ id, handle }) => {
      const li = document.createElement('li');
      li.className = 'grid__item';
      li.dataset.pid = `pid-${id}`;
      container.appendChild(li);
      getProductCardHTMLByHandle(handle, id);
    });
    document.querySelector('.cart-drawer-recommendations__heading').style.removeProperty('display');
  }

  async function getProductCardHTMLByHandle(handle, pid) {
    const url = `${window.Shopify.routes.root}products/${handle}?view=product-card-mini`;

    try {
      const res = await fetch(url);
      const html = await res.text();

      if (html.indexOf('404 Not Found') !== -1) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.custom-section-content');
      const productCardHTML = section ? section.outerHTML : '';

      const target = document.querySelector(`[data-pid="pid-${pid}"]`);
      if (target) target.innerHTML = productCardHTML;
    } catch (err) {
      console.error(`Failed to load product card for ${handle}:`, err);
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Failed to load cart');
    return res.json();
  }
})();